module.exports = __webpack_public_path__ + "img/philco.13ecd235.png";